import { render, staticRenderFns } from "./customerGroupInfo.vue?vue&type=template&id=6b593e53&scoped=true"
import script from "./customerGroupInfo.vue?vue&type=script&lang=js"
export * from "./customerGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./customerGroupInfo.vue?vue&type=style&index=0&id=6b593e53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b593e53",
  null
  
)

export default component.exports